import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { useCallback, useRef, useState } from 'react';
import { IContentFieldProps } from 'types/fields';
import ContentTextField from './ContentTextField';

const IdPInputSecretField: React.FC<IContentFieldProps> = ({
	name,
	displayName,
	disabled,
	value,
	onChange,
	required,
	error
}) => {
	const inputRef = useRef<HTMLInputElement | null>(null);
	const [passwordVisible, setPasswordVisible] = useState(false);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			onChange(e.target.value);
		},
		[onChange]
	);

	return (
		<ContentTextField
			data-testid="field-secret"
			key={name}
			type={!passwordVisible ? 'password' : 'text'}
			name={name}
			label={displayName}
			disabled={disabled}
			required={required}
			value={value || ''}
			onChange={handleChange}
			slotProps={{
				htmlInput: {
					role: 'textbox',
					ref: inputRef,
					onClick: () => {
						/* istanbul ignore next:  */
						inputRef.current?.select();
					}
				},
				input: {
					sx: { width: '100%' },
					endAdornment: !disabled && (
						<IconButton
							size="small"
							sx={{ p: 0 }}
							data-testid="password-visibility-button"
							onClick={() => setPasswordVisible(!passwordVisible)}
						>
							{passwordVisible ? (
								<VisibilityOff fontSize="small" />
							) : (
								<Visibility fontSize="small" />
							)}
						</IconButton>
					)
				}
			}}
			error={Boolean(error)}
			helperText={error}
		/>
	);
};

export default IdPInputSecretField;
